<template>
  <div>
    <RelatorioRetrato>
      <b-card class="fundoRelatorio cabecalhoTable">
        <div v-for="(linhaDaTabela, indice) in parametro.dados" :key="`tabelaItem_${indice}`">
          <div class="fundoRelatorio titulo">
            <div class="d-none d-lg-flex align-items-center fundoRelatorio">
              <img :src="logoAgenda" alt="logoAgenda" />
              <h2 class="brand-text text-primary ml-1" style="margin-bottom: 0px; margin-left: 0px !important">Agenda Bank</h2>
            </div>
            <div class="lineBlue"></div>
            <div class="lineGray"></div>
            <h1 class="fundoRelatorio instituto" style="margin-bottom: 0px; margin-top: 5px">
              {{ parametro.institutoNome }}
            </h1>
          </div>

          <!-- Nome do Relatório -->
          <div class="fundoRelatorio tituloRelatorio">Relatório de Simulador Externo</div>

          <b-table
            striped
            small
            class="ExportarPDFParcela mt-3 custom-header-style"
            :class="parametro.dados.length - 1 == indice ? 'UltimaTable' : ''"
            style="text-align: center"
            id="table_export_id"
            :head-variant="'light'"
            :items="linhaDaTabela"
            :fields="parametro.colunas"
          >
          </b-table>

          <div v-if="parametro.dados.length - 1 == indice && linhaDaTabela.length == 37" class="html2pdf__page-break" />
          <div v-if="parametro.dados.length - 1 != indice" class="html2pdf__page-break" />
        </div>
      </b-card>
    </RelatorioRetrato>
  </div>
</template>

<script>
  import pdfMake from 'pdfmake/build/pdfmake'
  import pdfFonts from 'pdfmake/build/vfs_fonts'
  import RelatorioRetrato from '@/views/pages/relatorio/relatorioRetrato.vue'
  import { formatarData, formatarParaNumber, formatarValor, formatarValorPorcentagem } from '@/libs/utils'

  export default {
    components: {
      RelatorioRetrato,
      pdfMake,
      pdfFonts,
      formatarValor,
      formatarData,
    },
    props: {
      parametro: {},
    },
    data() {
      return {
        aImg: require('@/assets/images/logo/Alogo2.png'),
        userData: this.$jwtDecode(localStorage.getItem('userData')).userData,

        formatarValor,
        formatarData,
      }
    },
    computed: {
      logoAgenda() {
        return this.userData.Instituto?.logoRelatorio?.logo ?? this.aImg
      },
    },
  }
</script>

<style>
  .fundoRelatorio {
    background-color: white;
    word-break: break-word;
  }

  .titulo {
    background-color: inherit !important;
    justify-content: flex-start;
    word-break: break-all;
    padding-top: 5px;
  }

  .ExportarPDFParcela .thead-light th {
    background-color: #f3f2f700 !important;
    border-color: #4941a6 !important;
    border-block-start: initial !important;
    color: #4941a6 !important;
    font-size: 10px !important;
    padding: 10.5px 0 !important;
    inline-size: max-content !important;
  }

  .lineBlue {
    width: 288px;
    height: 13px;
    background-color: #4941a6;
  }
  .lineGray {
    width: 563px;
    height: 13px;
    background-color: #b8c2cb;
  }
  .instituto {
    font-size: initial;
    padding-left: 20px;
  }
  .tituloRelatorio {
    text-align: center;
    font-weight: bold;
    font-size: large;
    color: #615771;
  }
  .cabecalhoTable {
    margin-bottom: 0px;
    font-size: 9px;
    word-wrap: normal;
    white-space: pre-wrap;
  }

  .periodoRelatorio {
    font-weight: bold;
    color: black;
    text-align: center;
  }

  .totalParcelas {
    font-weight: bold;
    color: black;
    font-size: 9px;
    padding-bottom: 2px;
    padding-left: 20px;
  }

  .rodapeRelatorio {
    font-size: 11px;
    margin-bottom: 0px;
    color: #736c81;
    margin-top: 5px;
    padding-left: 20px;
  }

  .rodapeRelatorioContainer {
    bottom: 0rem;
  }

  .content-wrapper {
    position: relative;
  }

  .bold-footer-row {
    font-weight: normal;
  }

  #ExportarPDFParcelaId thead tr th {
    width: 100px;
  }

  #ExportarPDFParcelaId tbody tr td {
    padding: 3px !important;
  }

  .UltimaTable tbody tr:last-child {
    font-weight: normal;
  }

  #logoAgenda {
    margin: 0 10px;
  }

  div.vue-html2pdf div.card-body {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .ExportarPDFParcela {
    padding-top: 15px !important;
    padding-bottom: 15px !important;
  }

  .margemTotalizador {
    margin-top: 30px;
  }

  .ExportarPDFParcela tbody tr td {
    text-wrap: nowrap;
  }

  .mt-07 {
    margin-top: 0.7rem !important;
  }

  .mt-05 {
    margin-top: 0.5rem !important;
  }

  #radiosTipoDePesquisa > label {
    width: 0.5em;
  }

  #ExportarPDFParcelaId tbody > tr > td {
    font-size: 0.55rem !important;
  }
</style>
